import Store from "./store";
import flatpickr from "flatpickr";
import * as api from "./global/api";
import method from "./global/method";
import defaultSetting from "./config.js";
import server from "./controllers/server";
import { locales } from "./locale/locale";
import { common_extend } from "./utils/util";
import { setcellvalue } from "./global/setdata";
import { printInitial } from "./utils/print.js";
import { zoomInitial } from "./controllers/zoom";
import Mandarin from "flatpickr/dist/l10n/zh.js";
import { handlePrint } from "./controllers/print";
import { ajaxWithHeaders } from "./utils/ajax.js";
import functionlist from "./function/functionlist";
import sheetmanage from "./controllers/sheetmanage";
import { initListener } from "./controllers/listener";
import luckysheetHandler from "./controllers/handler";
import { orderByInitial } from "./controllers/orderBy";
import { keyboardInitial } from "./controllers/keyboard";
import { initialSheetBar } from "./controllers/sheetBar";
import { luckysheetextendData } from "./global/extend.js";
import { initPlugins } from "./controllers/expendPlugins";
import { setluckysheet_select_save } from "./methods/set";
import { selectHightlightShow } from "./controllers/select";
import { initialFilterHandler } from "./controllers/filter";
import { formulaBarInitial } from "./controllers/formulaBar";
import { luckysheetlodingHTML } from "./controllers/constant";
import { getcellvalue, getdatabyselection } from "./global/getdata";
import { initialMatrixOperation } from "./controllers/matrixOperation";
import { luckysheetrefreshgrid, jfrefreshgrid } from "./global/refresh";
import luckysheetConfigsetting from "./controllers/luckysheetConfigsetting";
import { rowColumnOperationInitial } from "./controllers/rowColumnOperation";
import { hideloading, showloading, setloadingcolor } from "./global/loading.js";
import { getluckysheetfile, getluckysheet_select_save, getconfig } from "./methods/get";
import { cellProtectionCtrl } from "./controllers/cellProtection.js";

let luckysheet = {};

/**
 * @description 合并 API
 */
luckysheet = common_extend(api, luckysheet);

//创建luckysheet表格
luckysheet.create = function (setting) {
    method.destroy();
    // Store original parameters for api: toJson
    Store.toJsonOptions = {};
    for (let c in setting) {
        if (c !== "data") {
            Store.toJsonOptions[c] = setting[c];
        }
    }

    let extendsetting = common_extend(defaultSetting, setting);

    let loadurl = extendsetting.loadUrl,
        menu = extendsetting.menu,
        title = extendsetting.title;

    let container = extendsetting.container;
    Store.container = container;
    Store.luckysheetfile = extendsetting.data;

    // 图片显示方式
    Store.imageMode = extendsetting.imageMode || "float"; // 'cell' | 'float'

    Store.defaultcolumnNum = extendsetting.column;
    Store.defaultrowNum = extendsetting.row;
    Store.defaultFontSize = extendsetting.defaultFontSize;
    Store.fullscreenmode = extendsetting.fullscreenmode;
    Store.lang = extendsetting.lang; //language
    Store.allowEdit = extendsetting.allowEdit;
    Store.limitSheetNameLength = extendsetting.limitSheetNameLength;
    Store.defaultSheetNameMaxLength = extendsetting.defaultSheetNameMaxLength;
    Store.fontList = extendsetting.fontList;
    server.gridKey = extendsetting.gridKey;
    server.loadUrl = extendsetting.loadUrl;
    server.updateUrl = extendsetting.updateUrl;
    server.updateImageUrl = extendsetting.updateImageUrl;
    server.title = extendsetting.title;
    server.loadSheetUrl = extendsetting.loadSheetUrl;
    server.allowUpdate = extendsetting.allowUpdate;

    luckysheetConfigsetting.autoFormatw = extendsetting.autoFormatw;
    luckysheetConfigsetting.accuracy = extendsetting.accuracy;
    luckysheetConfigsetting.total = extendsetting.data[0].total;

    luckysheetConfigsetting.loading = extendsetting.loading;
    luckysheetConfigsetting.allowCopy = extendsetting.allowCopy;
    luckysheetConfigsetting.showtoolbar = extendsetting.showtoolbar;
    luckysheetConfigsetting.showtoolbarConfig = extendsetting.showtoolbarConfig;
    luckysheetConfigsetting.showinfobar = extendsetting.showinfobar;

    luckysheetConfigsetting.showsheetbar = extendsetting.showsheetbar;
    luckysheetConfigsetting.showsheetbarConfig = extendsetting.showsheetbarConfig;
    luckysheetConfigsetting.showstatisticBar = extendsetting.showstatisticBar;
    luckysheetConfigsetting.showstatisticBarConfig = extendsetting.showstatisticBarConfig;
    luckysheetConfigsetting.sheetFormulaBar = extendsetting.sheetFormulaBar;
    luckysheetConfigsetting.cellRightClickConfig = extendsetting.cellRightClickConfig;
    luckysheetConfigsetting.sheetRightClickConfig = extendsetting.sheetRightClickConfig;
    luckysheetConfigsetting.pointEdit = extendsetting.pointEdit;
    luckysheetConfigsetting.pointEditUpdate = extendsetting.pointEditUpdate;
    luckysheetConfigsetting.pointEditZoom = extendsetting.pointEditZoom;

    luckysheetConfigsetting.userInfo = extendsetting.userInfo;
    luckysheetConfigsetting.userMenuItem = extendsetting.userMenuItem;
    luckysheetConfigsetting.myFolderUrl = extendsetting.myFolderUrl;
    luckysheetConfigsetting.functionButton = extendsetting.functionButton;

    luckysheetConfigsetting.showConfigWindowResize = extendsetting.showConfigWindowResize;
    luckysheetConfigsetting.enableAddRow = extendsetting.enableAddRow;
    luckysheetConfigsetting.enableAddBackTop = extendsetting.enableAddBackTop;
    luckysheetConfigsetting.addRowCount = extendsetting.addRowCount;
    luckysheetConfigsetting.enablePage = extendsetting.enablePage;
    luckysheetConfigsetting.pageInfo = extendsetting.pageInfo;

    luckysheetConfigsetting.editMode = extendsetting.editMode;
    luckysheetConfigsetting.beforeCreateDom = extendsetting.beforeCreateDom;
    luckysheetConfigsetting.workbookCreateBefore = extendsetting.workbookCreateBefore;
    luckysheetConfigsetting.workbookCreateAfter = extendsetting.workbookCreateAfter;
    luckysheetConfigsetting.remoteFunction = extendsetting.remoteFunction;
    luckysheetConfigsetting.customFunctions = extendsetting.customFunctions;

    luckysheetConfigsetting.fireMousedown = extendsetting.fireMousedown;
    luckysheetConfigsetting.forceCalculation = extendsetting.forceCalculation;
    luckysheetConfigsetting.plugins = extendsetting.plugins;

    luckysheetConfigsetting.rowHeaderWidth = extendsetting.rowHeaderWidth;
    luckysheetConfigsetting.columnHeaderHeight = extendsetting.columnHeaderHeight;

    luckysheetConfigsetting.defaultColWidth = extendsetting.defaultColWidth;
    luckysheetConfigsetting.defaultRowHeight = extendsetting.defaultRowHeight;

    luckysheetConfigsetting.title = extendsetting.title;
    luckysheetConfigsetting.container = extendsetting.container;
    luckysheetConfigsetting.hook = extendsetting.hook;

    // 2025-09-22 新增打印像素比优化
    luckysheetConfigsetting.printDevicePixelRatio = extendsetting.printDevicePixelRatio;

    // 2025-09-26 新增用户自定义快捷键功能
    luckysheetConfigsetting.customShortcutKeys = extendsetting.customShortcutKeys;

    // 20260117 兼容 remoteSelectOptions 配置
    luckysheetConfigsetting.remoteSelectOptions = extendsetting.remoteSelectOptions;

    // 菜单功能用户注册事件
    luckysheetConfigsetting.menuHandler = extendsetting.menuHandler;

    // 隐藏logo
    luckysheetConfigsetting.showlogo = extendsetting.showlogo;

    // 添加请求头实现
    luckysheetConfigsetting.requestHeaders = extendsetting.requestHeaders;

    luckysheetConfigsetting.pager = extendsetting.pager;

    luckysheetConfigsetting.initShowsheetbarConfig = false;

    luckysheetConfigsetting.imageUpdateMethodConfig = extendsetting.imageUpdateMethodConfig;

    if (Store.lang === "zh") flatpickr.localize(Mandarin.zh);

    // Store the currently used plugins for monitoring asynchronous loading
    Store.asyncLoad.push(...luckysheetConfigsetting.plugins);

    // // Register plugins
    // initPlugins(extendsetting.plugins, extendsetting.data);

    // Store formula information, including internationalization
    functionlist(extendsetting.customFunctions);

    let devicePixelRatio = extendsetting.devicePixelRatio;
    if (devicePixelRatio == null) {
        devicePixelRatio = 1;
    }

    Store.devicePixelRatio = Math.ceil(devicePixelRatio);

    //loading
    const loadingObj = luckysheetlodingHTML("#" + container);
    Store.loadingObj = loadingObj;

    // 执行后续操作
    initLuckysheet(loadurl, menu, title, extendsetting, Store.loadingObj);
};

/**
 * @description 测试用例
 */
function demoTest() {
    setTimeout(() => {
        // cellProtectionCtrl.preview()
        // handlePrint({ mode: "sheet" });
    }, 1000);
}

/**
 * @description 执行后续的 luckysheet 初始化工作，包括是否执行协同 | 初始化插件 等
 */
function initLuckysheet(loadurl, menu, title, extendsetting, loadingObj) {
    if (loadurl == "") {
        initPlugins(extendsetting.plugins, extendsetting.data);
        sheetmanage.initialjfFile(menu, title);
        initialWorkBook();
    } else {
        // 修改 $post 方法，改为 $ajax() 以实现添加请求头的功能 - requestHeaders
        ajaxWithHeaders({
            url: server.loadUrl,
            data: { gridKey: server.gridKey },
            headers: extendsetting.requestHeaders,
            success: function (d) {
                if (d.code === 400) {
                    loadingObj.close();
                    sheetmanage.initialjfFile(menu, title);
                    initialWorkBook();
                    showloading("当前协同 gridKey 未查询到相关数据");
                    setloadingcolor("#F56C6C");
                    throw new Error(`${d.msg},请检查 loadSheetData 相关接口。`);
                }

                // 不然就正常渲染
                let data = new Function("return " + d)();
                Store.luckysheetfile = data;
                // 协同请求到数据后，再执行 init plugin
                initPlugins(extendsetting.plugins, data);
                sheetmanage.initialjfFile(menu, title);
                initialWorkBook();
                //需要更新数据给后台时，建立WebSocket连接
                if (server.allowUpdate) {
                    server.openWebSocket();
                }
            },
            error: function (error) {
                // 向上暴露错误 error 不能阻塞渲染
                console.error("协同服务异常，请检查后重试！", error);
                loadingObj.close();
                sheetmanage.initialjfFile(menu, title);
                initialWorkBook();
                showloading("协同服务异常，请检查后重试！");
                setloadingcolor("#F56C6C");
            },
        });
    }
}

/**
 * @description 初始化工作表
 */
function initialWorkBook() {
    luckysheetHandler(); //Overall dom initialization
    initialFilterHandler(); //Filter initialization
    initialMatrixOperation(); //Right click matrix initialization
    initialSheetBar(); //bottom sheet bar initialization
    formulaBarInitial(); //top formula bar initialization
    rowColumnOperationInitial(); //row and coloumn operate initialization
    keyboardInitial(); //Keyboard operate initialization
    orderByInitial(); //menu bar orderby function initialization
    zoomInitial(); //zoom method initialization
    printInitial(); //print initialization
    initListener(); // jfredo jfundo
    demoTest(); // demo test
}

//获取所有表格数据
luckysheet.getluckysheetfile = getluckysheetfile;

//获取当前表格 选区
luckysheet.getluckysheet_select_save = getluckysheet_select_save;

//设置当前表格 选区
luckysheet.setluckysheet_select_save = setluckysheet_select_save;

//获取当前表格 config配置
luckysheet.getconfig = getconfig;

//二维数组数据 转化成 {r, c, v}格式 一维数组 (传入参数为二维数据data)
luckysheet.getGridData = sheetmanage.getGridData;

//生成表格所需二维数组 （传入参数为表格数据对象file）
luckysheet.buildGridData = sheetmanage.buildGridData;

// Refresh the canvas display data according to scrollHeight and scrollWidth
luckysheet.luckysheetrefreshgrid = luckysheetrefreshgrid;

// Refresh canvas
luckysheet.jfrefreshgrid = jfrefreshgrid;

// Get the value of the cell
luckysheet.getcellvalue = getcellvalue;

// Set cell value
luckysheet.setcellvalue = setcellvalue;

// Get selection range value
luckysheet.getdatabyselection = getdatabyselection;

luckysheet.sheetmanage = sheetmanage;

// Data of the current table
luckysheet.flowdata = () => Store.flowdata;

// Set selection highlight
luckysheet.selectHightlightShow = selectHightlightShow;

// Reset parameters after destroying the table
luckysheet.destroy = method.destroy;

luckysheet.showLoadingProgress = showloading;
luckysheet.hideLoadingProgress = hideloading;
luckysheet.luckysheetextendData = luckysheetextendData;

luckysheet.locales = locales;

export { luckysheet };
